module.exports = __webpack_public_path__ + "img/ABLFrictionSandTeflon-min.da551fa7.png";